export default "__VITE_ASSET__ck80kodw__";